import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Heading } from '@/components/ui/typography';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Stack } from '@/components/ui/layout';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

function Language({ onUpdate, existingLanguages = [] }) {
  const languageOptions = ['English', 'Hindi', 'Spanish', 'French', 'German', 'Mandarin', 'Japanese', 'Russian'];
  const proficiencyLevels = ['Beginner', 'Intermediate', 'Advanced', 'Fluent', 'Native'];

  const [languages, setLanguages] = useState(existingLanguages || []);


  useEffect(() => {
    onUpdate(languages);
  }, [languages]);

  const handleLanguageChange = (index, key, value) => {
    const updatedLanguages = [...languages];
    updatedLanguages[index] = { ...updatedLanguages[index], [key]: value };
    setLanguages(updatedLanguages);
  };

  const addLanguage = () => {
    setLanguages([...languages, { language: '', proficiency: '' }]);
  };

  return (
    <Card className="mb-6 bg-white">
      <CardContent className="p-4">
        <Heading level="h2" className="text-base font-semibold mb-3">Language</Heading>
        <Stack spacing="md">
          {languages.map((lang, index) => (
            <div key={index} className={cn("grid grid-cols-2 gap-4 items-end")}>
              <div>
                <Label htmlFor={`language${index}`}>Language</Label>
                <Select
                  value={lang.language}
                  onValueChange={(value) => handleLanguageChange(index, 'language', value)}
                >
                  <SelectTrigger className="mt-1">
                    <SelectValue placeholder="Select language" />
                  </SelectTrigger>
                  <SelectContent>
                    {languageOptions.map((language, i) => (
                      <SelectItem key={i} value={language}>{language}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label htmlFor={`proficiency${index}`}>Proficiency</Label>
                <Select
                  value={lang.proficiency}
                  onValueChange={(value) => handleLanguageChange(index, 'proficiency', value)}
                >
                  <SelectTrigger className="mt-1">
                    <SelectValue placeholder="Select level" />
                  </SelectTrigger>
                  <SelectContent>
                    {proficiencyLevels.map((level, i) => (
                      <SelectItem key={i} value={level}>{level}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </div>
          ))}
          <Button variant="outline" onClick={addLanguage} className="w-full">
            Add Language
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default Language;